import { isObject, isString } from '@/utils'
import {
  complement,
  fromPairs,
  head,
  includes,
  isNil,
  last,
  length,
  lt,
  pipe,
  prop,
  reject,
  toPairs,
  when,
  __,
} from 'ramda'

import de from 'react-phone-number-input/locale/de.json'
import en from 'react-phone-number-input/locale/en.json'

type ErrorValue = string | Record<string, any> | null | undefined
type IgnoreList = string[]
type LocaleData = Record<string, string>

const ignoreErrors = (ignore: IgnoreList) =>
  pipe(
    toPairs,
    reject(pipe(head, includes(__, ignore))),
    head,
    when(complement(isNil), last),
  ) as (error: Record<string, any>) => string | null

export const getError = (
  error: ErrorValue,
  ignore: IgnoreList = [],
): string | null => {
  if (isString(error)) return error

  const makeError = ignoreErrors(ignore)

  if (isObject(error)) return makeError(error)

  return null
}

export const makeCountries = pipe(
  prop(__, { en, de } as Record<string, LocaleData>),
  toPairs,
  reject(pipe(head, (key: string) => length(key), lt(2))),
  fromPairs,
)
